import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'
import { palette, spacing } from '../constants'
import { Text } from '../typography'

interface IProps {
  full: boolean
  small?: boolean
}

const ButtonBase = styled(Text.withComponent('button'))<IProps>`
  height: ${({ small }) => (small ? '35px' : '55px')};
  width: ${({ full }) => (full ? '100%' : 'auto')};
  border: 1px solid;
  border-radius: 3px;
  cursor: pointer;
  padding: 0 ${spacing.majorScale(3)}px;
  outline: none;

  // HACK (alex): cross-bundle compatibility
  margin: 0;
`

export const ButtonRegular = styled(ButtonBase)`
  color: ${palette.white};
  background: ${palette.skyBlue2};
  border-color: ${palette.skyBlue2};

  &:hover {
    background: ${darken(0.1, palette.skyBlue2)};
    border-color: ${darken(0.1, palette.skyBlue2)};
  }

  &:disabled {
    background: ${palette.chrome};
    border-color: ${palette.chrome};
  }
`

export const ButtonOutline = styled(ButtonBase)`
  color: ${palette.skyBlue2};
  background: ${palette.white};
  border-color: ${palette.chrome};

  &:hover {
    background: ${palette.whiteDove};

    // HACK (alex): cross-bundle compatibility
    border-color: ${palette.chrome};
    color: ${palette.skyBlue2};
  }

  &:disabled {
    color: ${palette.chrome};
    background: ${palette.white};
  }
`

export const ButtonSoftDisabled = styled(ButtonBase)`
  color: ${palette.white};
  background: ${palette.chrome};
  border-color: ${palette.chrome};
  outline: none;
`

export const ButtonDanger = styled(ButtonBase)`
  color: ${palette.white};
  background: ${palette.poppy2};
  border-color: ${palette.poppy2};

  &:hover {
    background: ${darken(0.1, palette.poppy2)};
    border-color: ${darken(0.1, palette.poppy2)};
  }

  &:disabled {
    background: ${palette.chrome};
    border-color: ${palette.chrome};
  }
`

export const ButtonAlternate = styled(ButtonBase)`
  color: ${palette.white};
  background: ${palette.goldenrod};
  border-color: ${palette.goldenrod};
  outline: none;

  &:hover {
    background: ${darken(0.1, palette.goldenrod)};
    border-color: ${darken(0.1, palette.goldenrod)};
  }

  &:disabled {
    background: ${palette.chrome};
    border-color: ${palette.chrome};
  }
`

export const ButtonRounded = styled(ButtonBase)`
  color: ${palette.white};
  background: ${palette.indigo};
  border-color: ${palette.indigo};
  border-radius: ${spacing.majorScale(1)}px;
  transition: background 0.2s ease-in;
  &:hover {
    background: ${palette.skyBlue};
    border-color: ${palette.skyBlue};
  }

  &:disabled {
    background: ${palette.chrome};
    border-color: ${palette.chrome};
  }
`
